import {
  BackupSettingsAction,
  LOAD_BACKUP_SETTINGS,
  LOAD_BACKUP_SETTINGS_FAIL,
  LOAD_BACKUP_SETTINGS_SUCCESS,
} from '../actions/backup-settings.action';
import {IBackupsSettings} from "../../websites/website/backup/backups-settings.interface";

export interface IBackupSettingsEntityState {
  entities: IBackupsSettings;
  loading: boolean;
  loaded: boolean;
}

export interface IBackupSettingsState {
  entities: { [websiteId: number]: IBackupSettingsEntityState };
}

export const initialState: IBackupSettingsState = {
  entities: {},
};

export function reducer(
  state: IBackupSettingsState = initialState,
  action: BackupSettingsAction
): IBackupSettingsState {
  switch (action.type) {
    case LOAD_BACKUP_SETTINGS:
      return {
        ...state,
        entities: {
          ...state.entities,
          [action.payload]: {
            ...state.entities[action.payload],
            loading: true,
            loaded: false,
          },
        },
      };

    case LOAD_BACKUP_SETTINGS_SUCCESS:
      return {
        ...state,
        entities: {
          ...state.entities,
          [action.payload.websiteId]: {
            ...state.entities[action.payload.websiteId],
            entities: action.payload.entities,
            loading: false,
            loaded: true,
          },
        },
      };

    case LOAD_BACKUP_SETTINGS_FAIL:
      return {
        ...state,
        entities: {
          ...state.entities,
          [action.payload.websiteId]: {
            ...state.entities[action.payload.websiteId],
            loading: false,
            loaded: false,
          },
        },
      };

    default:
      return state;
  }
}
